"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function ShopTheLookSectionConsumer() {
  const {
    products,
    loading
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="225105" className="w-full aspect-[4/5] md:aspect-[21/9] bg-muted/20 animate-pulse flex items-center justify-center rounded-3xl">
        <div className="w-48 h-12 bg-muted/30 rounded-full" />
      </div>;
  }
  const product = products[0];
  const imageUrl = product?.featured_image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640790/img/nurturing_doula_moment.png";
  return <div className="relative w-full overflow-hidden group rounded-3xl shadow-xl">
      <img src={imageUrl} data-wvc-srcset={`${imageUrl}-wvc-srcset`} data-wvc-sizes={`${imageUrl}-wvc-sizes`} alt="Nurturing birth support and comfort" className="w-full h-full object-cover aspect-[4/5] md:aspect-[21/9] transition-transform duration-1000 group-hover:scale-105" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent md:bg-background/30 md:backdrop-blur-[2px] flex items-center justify-center p-8">
        <div className="w-full max-w-md text-center space-y-6">
          <div className="space-y-2">
            <h2 className="text-2xl md:text-4xl font-serif text-primary drop-shadow-sm">
              Your Peace is My Mission
            </h2>
            <p className="text-sm md:text-base font-sans text-primary/80 max-w-xs mx-auto">
              Nurturing support for every step of your sacred journey into motherhood.
            </p>
          </div>
          
          <div className="w-full">
            {product ? <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground hover:bg-primary/90 w-full py-6 text-sm md:text-base font-serif tracking-wide transition-all duration-300 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" text="Begin Your Peaceful Journey — Book Now" showQuantity={false} /> : <Link to="/LetsConnectPage" className="flex w-full items-center justify-center bg-primary text-primary-foreground hover:bg-primary/90 py-6 text-sm md:text-base font-serif tracking-wide transition-all duration-300 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
                Begin Your Peaceful Journey — Book Now
              </Link>}
          </div>
          <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-primary/60 font-sans">
            Complimentary Consultations Available
          </p>
        </div>
      </div>
    </div>;
}
export default function ShopTheLookSection() {
  const wp_query_params = {
    per_page: 1
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}